import React from "react";

import { useStorage } from "@tableplus/toolkit";
import { Border, Footer, ResizeDiv } from "@tableplus/toolkit";
import { scrollbar } from "@moai/core";
import { Edit } from "./edit/edit";
import { View } from "./view/view";
import { usePrefs } from "../prefs/prefs";
import { getRandomSample } from "./sample";
import s from "./app.module.scss";

const fallback = getRandomSample();

export const App = () => {
    const prefs = usePrefs();
    const [value, setValue] = useStorage("value", fallback);
    const [width, setWidth] = useStorage("width", 0.5);

    const body = (
        <div className={s.body}>
            <div className={s.edit} style={{ flexGrow: width }}>
                <Edit {...{ prefs, value, setValue }} />
            </div>
            <div className={s.resize}>
                <ResizeDiv setWidth={setWidth} />
            </div>
            <div className={s.line}>
                <Border color="strong" />
            </div>
            <div className={s.view} style={{ flexGrow: 1 - width }}>
                <View prefs={prefs} value={value} />
            </div>
        </div>
    );

    return (
        <div className={`${s.app} ${scrollbar.custom}`}>
            {body}
            <Border color="strong" />
            <div className={s.footer}>
                <Footer dataText="JSON" />
            </div>
        </div>
    );
};
